// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Skeleton__tabsContainer--2EG","tabs":"Skeleton__tabs--2GP","tab":"Skeleton__tab--155"};